import { Button, Select, Typography } from 'antd'
import { ReactNode } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const DocumentAttachments = ({
  label,
  documents,
  selectedIds,
  loading,
  readonly,
  onChange,
  onOpen,
  uploader,
}: {
  label: string
  documents: readonly { id: string; name: string }[]
  selectedIds: readonly string[]
  loading: boolean
  readonly: boolean
  onChange: (ids: string[]) => void
  onOpen: (id: string) => void
  uploader: ReactNode
}) => (
  <Container>
    {!readonly && (
      <Select
        aria-label={label}
        mode='multiple'
        placeholder='Select asset documents'
        showSearch
        optionFilterProp='label'
        loading={loading}
        disabled={loading}
        value={[...selectedIds]}
        options={documents.map((document) => ({
          value: document.id,
          label: document.name,
        }))}
        onChange={onChange}
      />
    )}
    {selectedIds.map((id) => {
      const document = documents.find((item) => item.id === id)
      return document ? (
        <Button key={id} type='link' onClick={() => onOpen(id)}>
          {document.name}
        </Button>
      ) : (
        <Typography.Text key={id} type='secondary'>
          {loading ? 'Loading document' : 'Document unavailable'}: {id}
        </Typography.Text>
      )
    })}
    {readonly && !selectedIds.length && (
      <Typography.Text type='secondary'>No files attached.</Typography.Text>
    )}
    {!readonly && uploader}
  </Container>
)
